function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { isArray } from '@okee-uikit/react-utils';
import { ColumnType } from '../../../models/table';
import { TableCellHead } from '../cell/TableCellHead';
import { TableCellData } from '../cell/TableCellData';
export function convertColumn(info) {
  if (isArray(info.children)) {
    return {
      type: ColumnType.GROUP,
      key: "".concat(info.id),
      show: info.show,
      fixed: info.fixed,
      children: info.children.map(function (item) {
        return convertColumn(item);
      }),
      renderHead: convertRenderHead(info)
    };
  }

  return {
    type: ColumnType.LEAF,
    key: "".concat(info.id),
    show: info.show,
    fixed: info.fixed,
    width: info.width || 100,
    widthFixed: info.widthFixed,
    renderHead: convertRenderHead(info),
    renderData: convertRenderCell(info)
  };
}
export function convertRenderHead(info) {
  return function () {
    return React.createElement(TableCellHead, {
      info: info
    });
  };
}
export function convertRenderCell(info) {
  var render = info.render,
      cellProps = info.cellProps,
      className = info.className;
  return function (row, rowInfo, startContent, endContent) {
    return React.createElement(TableCellData, _objectSpread({
      className: className
    }, cellProps === null || cellProps === void 0 ? void 0 : cellProps(rowInfo)), startContent, render(rowInfo), endContent);
  };
}